/* global axios */
import ApiClient from './ApiClient';

class ContactConsentsAPI extends ApiClient {
  constructor() {
    super('talkvia_contact_consents', { accountScoped: true });
  }

  create(data) {
    return axios.post(this.url, data);
  }

  cancel(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  renew(id, data = {}) {
    return axios.post(`${this.url}/${id}/renew`, data);
  }

  deliver(id, data) {
    return axios.post(`${this.url}/${id}/deliver`, data);
  }
}

export default new ContactConsentsAPI();
